var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subject"},[_c('div',{staticClass:"subject-header"},[_vm._t("layer-subject-front")],2),_vm._v(" "),_c('div',{staticClass:"subject-body"},[_vm._t("subject-body-front"),_vm._v(" "),_vm._t("subject-body-cont"),_vm._v(" "),_vm._t("subject-body-info"),_vm._v(" "),_vm._t("subject-body-option"),_vm._v(" "),_vm._t("subject-body-end")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@13.7.3/~/vue-loader/lib/template-compiler?{"id":"data-v-21c63e8b","hasScoped":false,"buble":{"transforms":{}}}!./~/.store/vue-loader@13.7.3/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/examination/components/subjectlayout.vue
// module id = 1243
// module chunks = 72